import { createRoute, type AnyRoute } from "@tanstack/react-router";
import { Trophy } from "lucide-react";

import type { FeatureModule } from "@/features/types";
import { guarded } from "@/lib/auth";

import { GoalsPage } from "./pages/GoalsPage";

export const goalsModule: FeatureModule = {
  key: "goals",
  nav: {
    label: "Company Goals",
    icon: Trophy,
    to: "/goals",
    requires: "goals.read",
    order: 110,
    group: "Strategy",
  },
  routes: (rootRoute) => [
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/goals",
      component: guarded("goals.read", GoalsPage),
    }),
  ] as unknown as AnyRoute[],
};
